import ManageBankAccounts from '../../profile/manage-bank-account/manage-bank-accounts';

const BankAccounts = () => {
  return <ManageBankAccounts></ManageBankAccounts>
}

export default BankAccounts;